import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LotteryService {

  private baseURL: string;
  constructor(private http: HttpClient, private datePipe: DatePipe) {
    this.baseURL = environment.apiBaseUrl;
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Server error');
  }

  SaveLottery(lottery): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/Lottery/SaveLotteries`, lottery, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  RegenerateRandomLotteries(): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/Lottery/RegenerateRandomLotteries`, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  GenerateRandomLotteryForAllMarket(): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/Lottery/GenerateRandomLotteryForAllMarket`, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  GetMarketDaysForLottery(): Observable<any> {
    return this.http.get(`${this.baseURL}/Lottery/GetMarketDaysForLottery`, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  GetDayEndUserDetails1(fromDate: Date, marketId: number): Observable<any> {
    const formattedFromDate = this.datePipe.transform(fromDate, 'MM/dd/yyyy');
    return this.http.get(`${this.baseURL}/Lottery/GetDayEndUserDetails?fromDate=${formattedFromDate}&marketId=${marketId}`, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  GetDayEndUserDetails2(fromdate: Date, marketId: string): Observable<any[]> {
    const formattedFromDate = fromdate.toISOString();
    const url = `${this.baseURL}/DayEnd/GetDayEndUserDetails?MarketId=${marketId}&FromDate=${formattedFromDate}`;
    return this.http.get<any[]>(url, { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetDayEndUserDetails(fromdate: Date, marketId: string): Observable<any[]> {
    const formattedFromDate = fromdate.toISOString();
    const url = `${this.baseURL}/Lottery/GetDayEndUserDetails?MarketId=${marketId}&FromDate=${formattedFromDate}`;
    return this.http.get<any[]>(url, { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  HasVendorLotteryThisWeek(vendorId): Observable<any[]> {
    const url = `${this.baseURL}/Lottery/HasVendorLotteryThisWeek?vendorId=${vendorId}`;
    return this.http.get<any[]>(url, { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  DisplayLotteryTicket(accountReceiptId): Observable<any[]> {
    const url = `${this.baseURL}/Lottery/DisplayLotteryTicket?accountReceiptId=${accountReceiptId}`;
    return this.http.get<any[]>(url, { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }
}
